export default __webpack_public_path__ + "static/tutorial-header-img-d4ede700f607e10882e33171e6f8bff3.jpg";